import { ScholarshipsApiV2AdminClient } from '@studyportals/sp-scholarships-api-interface';
import { ResponseError } from 'superagent';
import { ScholarshipServiceRequestError } from '@/infrastructure/scholarship-service/scholarship-service-request-error';
import { ScholarshipServiceInternalError } from '@/infrastructure/scholarship-service/scholarship-service-internal-error';
import { ScholarshipServiceDataNotFoundError } from '@/infrastructure/scholarship-service/scholarship-service-data-not-found-error';

export class ScholarshipServiceIntegration {
	protected readonly v2Client: ScholarshipsApiV2AdminClient;

	public constructor() {
		this.v2Client = new ScholarshipsApiV2AdminClient(CONFIG.SCHOLARSHIP_API_V2_ADMIN_URI);
	}

	protected tryThrowAbstractedError(error: ResponseError): void {
		if (error.status === undefined) {
			return;
		}

		if (error.status === 404) {
			throw new ScholarshipServiceDataNotFoundError();
		}

		if (error.status >= 400 && error.status < 500) {
			throw new ScholarshipServiceRequestError();
		}

		if (error.status >= 500 && error.status < 600) {
			throw new ScholarshipServiceInternalError();
		}
	}
}
